const packageStatusLabels = [
    {
        title: 'Status Information',
        type: 'columns',
        fields: [
            {
                label: '[NOMBREEMPRESA]',
                description: 'company_name',
                visible: true
            },
            {
                label: '[FECHASTATUS]',
                description: 'status_date',
                visible: true
            },
            { label: '[STATUS]', description: 'status', visible: true },
            {
                label: '[CIUDADSTATUS]',
                description: 'status_city',
                visible: true
            },
            {
                label: '[COMENTARIOSTATUS]',
                description: 'status_comment',
                visible: true
            },
            {
                label: '[DETALLES]',
                description: 'package_details',
                visible: true
            }
        ]
    },
    {
        title: 'Agency',
        type: 'columns',
        fields: [
            {
                label: '[NOMBREAGENCIA]',
                description: 'agency_name',
                visible: true
            },
            {
                label: '[DIRECCIONAGENCIA]',
                description: 'agency_address',
                visible: true
            },
            {
                label: '[EMAILAGENCIA]',
                description: 'agency_email',
                visible: true
            },
            {
                label: '[TELEFONOAGENCIA]',
                description: 'agency_phone',
                visible: true
            }
        ]
    },
    {
        title: 'Agent & Links',
        type: 'columns',
        fields: [
            { label: '[AGENTE]', description: 'agent_name', visible: true },
            {
                label: '[LINKCASILLERO]',
                description: 'link_locker',
                visible: true
            },
            {
                label: '[LINKTRACKING]',
                description: 'link_tracking',
                visible: true
            },
            {
                label: '[LINKEMPRESA]',
                description: 'link_company',
                visible: true
            }
        ]
    }
];

export default packageStatusLabels;
